import { render, staticRenderFns } from "./Create-Salary.vue?vue&type=template&id=0098f673&scoped=true"
import script from "./Create-Salary.vue?vue&type=script&lang=js"
export * from "./Create-Salary.vue?vue&type=script&lang=js"
import style0 from "./Create-Salary.vue?vue&type=style&index=0&id=0098f673&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0098f673",
  null
  
)

export default component.exports